module.exports = __webpack_public_path__ + "static/media/Rider_Green.9938a135.svg";